
import SummaryRow from '../../components/Summary/SummaryRow';
import { useAppSelector } from '../../hooks';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';

type FieldInformationRowProps = {
    name: string;
    label: string;
    formatValue?: (value: any) => string;
};

const FieldSummaryRow = ({ name, label, formatValue }: FieldInformationRowProps) => {
    const field = useAppSelector(selectFieldStateByName)(name);

    if (!field || !field.value) {
        return null;
    }

    const formattedValue = formatValue
        ? `${formatValue(field.value)}`
        : field.label
          ? field.label
          : field.value.toString();

    return <SummaryRow value={formattedValue} label={label} showEditButton={false} />;
};
export default FieldSummaryRow;
